module.exports = __webpack_public_path__ + "static/img/rupixen-com-XNtPrVGo3cU-unsplash_thumb.fd702c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/rupixen-com-XNtPrVGo3cU-unsplash_thumb.png
// module id = /C41
// module chunks = 4